"use client";

import Input from "@/components/ui/input";
import { useScopedI18n } from "@/messages/client";
import { Column, Table } from "@tanstack/react-table";
import { Fragment, useMemo, useState } from "react";
import FliterContent from "../Filter/Content";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

function FilterItem<T>({
  column,
  table,
}: {
  column: Column<T, unknown>;
  table: Table<T>;
}) {
  return (
    <AccordionItem className="border-b border-[#ccc]" value={column.id}>
      <AccordionTrigger className="relative border-b border-[#dde2eb] bg-[#e8e8e8] px-4 py-3 text-xs md:px-6 md:py-4 md:text-sm">
        <span>
          {typeof column.columnDef.header === "string"
            ? column.columnDef.header
            : ""}
        </span>
        {column.getIsFiltered() && (
          <div className="absolute right-2 top-1/2 h-2 w-2 -translate-y-1/2 rounded-full bg-primary"></div>
        )}
      </AccordionTrigger>
      <AccordionContent className="border-r border-[#dde2eb] pb-0 md:pb-4">
        <FliterContent column={column} table={table} />
      </AccordionContent>
    </AccordionItem>
  );
}

export default function AllFilter<T>({ table }: { table: Table<T> }) {
  const t = useScopedI18n("选型器");

  const [search, setSearch] = useState("");

  const headers = table
    .getHeaderGroups()?.[0]
    ?.headers?.filter((i) => i.id !== "images" && i.id !== "material_number");

  const filterHeaders = useMemo(() => {
    if (!search.trim()) {
      return headers;
    }

    return headers?.filter((i) => {
      const header = i.column.columnDef.header as string;

      return header?.toLowerCase()?.includes(search.toLowerCase());
    });
  }, [headers, search]);

  return (
    <div className="w-[240px] flex-shrink-0 border-b border-l border-t border-[#ccc] bg-[#f8f8f8] md:w-[300px]">
      <div className="border-b border-[#ccc] px-3 py-2 md:px-6 md:py-4">
        <Input
          inputSize="sm"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="h-full w-full rounded-sm bg-white px-1 text-xs outline-none transition-colors duration-300 focus:border-primary"
          placeholder={t("搜索筛选项")}
        />
      </div>
      <div>
        <Accordion type="single" collapsible>
          {filterHeaders.map((header) => (
            <Fragment key={header.id}>
              {header.column.getCanFilter() && (
                <FilterItem column={header.column} table={table} />
              )}
            </Fragment>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
